import React, { PureComponent } from "react";
import Loader from "react-loaders";
import { orderBy } from "lodash";
import SweetAlert from "sweetalert-react";

import {
  getRequest,
  postRequest,
  deleteRequest,
  patchRequest,
  putRequest,
} from "../api/ApiService";
import { fetchAllStaticData } from "../api/StaticDataService";
import { fetchTeamDecisions, fetchTeamStatus } from "../api/TeamDecisionsService";
import { decimalsRound, logError } from "../services/utils";
import RoleButtons from "../components/role-buttons";
import Auth from "../routes/Auth";
import RoundNotStartedGate from "../components/round-not-started";
import FirstDecisionModal from "../components/first-decision-modal";
import Teams from "api/Teams";
import SubmitDecisionsButton from "../components/ui-building-blocks/buttons/submit-decisions";
import BuyingMachines from "../components/operations/helper-components/buying-machines";
import ProduceProduct from "../components/operations/helper-components/produce-product";
import ManageProductionPage from "../components/operations/decisions/manage-production-page";
import {
  submitDecisions,
  incrementUnacceptedDecisions,
  decrementUnacceptedDecisions,
} from "../api/SubmitDecisions";
import Styled from "components/operations/style";
import FinanceStyled from "components/finance/style";
import { view } from "@risingstack/react-easy-state";
import LastStepModal from "../components/get-started/last-step";
import EventEmitter from "../services/event-emitter";
//import GoogleMapReact from "google-map-react";
import IconTableHelp from "./assets/icon-table-help.svg";
import SelectFacilityPopup from "../components/operations/decisions/select-facility";

import MapImage from '../containers/assets/new-map-without-buttons.png';
import MapIcon1 from '../containers/assets/map-icon1.png';
import MapIcon2 from '../containers/assets/map-icon2.png';
import MapIcon3 from '../containers/assets/map-icon3.png';
import MapIcon4 from '../containers/assets/map-icon4.png';
import MapIcon5 from '../containers/assets/map-icon5.png';
import MapIcon6 from '../containers/assets/map-icon6.png';
import MapIcon7 from '../containers/assets/map-icon7.png';
import MapIcon8 from '../containers/assets/map-icon8.png';

import MapLines1 from '../containers/assets/map-lines1.png';
import MapLines2 from '../containers/assets/map-lines2.png';
import MapLines3 from '../containers/assets/map-lines3.png';

import TooltipImage1 from '../containers/assets/tooltip-image1.png';

import MapHoverIcon1 from '../containers/assets/map-hover-icon1.png';
import MapHoverIcon2 from '../containers/assets/map-hover-icon2.png';
import MapHoverIcon3 from '../containers/assets/map-hover-icon3.png';
import MapHoverIcon4 from '../containers/assets/map-hover-icon4.png';

import SmallCheckbox from '../containers/assets/small-checkbox.png';
import SmallCheckboxActive from '../containers/assets/small-checkbox-active.png';

import { numberFormat } from '../components/analysis/format';
import SuccessAlert from "../components/alerts/success";
import WarningAlert from "../components/alerts/warning";
import Fragment from "react-dot-fragment";

import DecisionsAlert from "../components/alerts/decisions";

const tooltipsPositions = {
  1: [205, 255],
  2: [145, 260],
  3: [5, 130],
  4: [250, 138],
  5: [5, 195],
  6: [135, 88],
  7: [135, 40],
  8: [177, 62],
  9: [205, 130],
  10: [205, 130],
  11: [160, 70],
  12: [40, 110],
  13: [95, 128],
  14: [55, 150],
};
// Customer dot center positions, calibrated against the rendered map.
// Mirrors the x/y values used inline by the <Styled.MapDot> elements
// below — kept in sync so the SVG lead-time lines line up exactly with
// the visible numbered dots.
const CUSTOMER_DOT_POSITIONS = [
  { id: 1, x: 377, y: 274 },
  { id: 2, x: 289, y: 262 },
  { id: 3, x: 37, y: 105 },
  { id: 4, x: 423, y: 147 },
  { id: 5, x: 42, y: 203 },
  { id: 6, x: 295, y: 223 },
  { id: 7, x: 269, y: 188 },
  { id: 8, x: 325, y: 212 },
  { id: 9, x: 209, y: 178 },
  { id: 10, x: 377, y: 122 },
  { id: 11, x: 487, y: 134 },
  { id: 12, x: 192, y: 233 },
  { id: 13, x: 401, y: 198 },
  { id: 14, x: 378, y: 224 },
];

// Distribution-center marker centers. The MapIcon styled component uses
// top-left positioning with a 30×30 icon, so add 15 to each axis to
// land on the visual center where lines should originate.
const DC_CENTER_POSITIONS = {
  1: { x: 338 + 15, y: 135 + 15 },
  2: { x: 275 + 15, y: 208 + 15 },
  3: { x: 111 + 15, y: 189 + 15 },
};

// Each candidate distribution center is operated by a different 3PL
// partner. Keyed by distribution_centers_info.type (1 = Toledo,
// 2 = Little Rock, 3 = Phoenix).
const DC_3PL_NAMES = {
  1: 'BXO Logistics',
  2: 'BEVA Logistics',
  3: 'BHL Supply Chain Logistics',
};

const customersLocations = {
  1: 'Jackson, AL',
  2: 'Garland, TX',
  3: 'Happy Valley, OR',
  4: 'Detroit, MI',
  5: 'Fremont, CA',
  6: 'Tulsa, OK',
  7: 'Ellsworth, KS',
  8: 'Springfield, MO',
  9: 'Littleton, CO',
  10: 'Sheboygan, WI',
  11: 'Henrietta, NY',
  12: 'Albuquerque, NM',
  13: 'Jeffersontown, KY',
  14: 'Dyersburg, TN',
};

class OperationsDecisions extends PureComponent {
  constructor(props) {
    super(props);

    this._isMounted = false;

    const { roundInUrl, currentRound, rounds } = props;

    const role = Auth.getRole();
    const hasAccess = role === "CEO" || role === "OP";
    const isOwnRole = role === "OP";

    this.state = {
      loaded: false,
      team_machines: [],
      products: [],
      isOwnRole,
      hasAccess,
      submission_data: {
        op: {
          date: "N/A",
          unaccepted: 0
        }
      },
      submitDecisionsLoading: true,
      loadingFactory: false,
      factories: [],
      overall_unit_utilization: 0,
      operation_spending: 0,
      operationSpendingBreakdown: [],
      showOpsSpendingTooltip: false,
      hoveredNotReleasedProductId: 0,
      roundInUrl,
      currentRound,
      rounds,
      selectFacilityPopupShown: false,
      facilityPopup: null,
      showDistributionCenters: false,
      canSelectDistributionCenters: false,
      activeDistributionCenter: 0,
      distribution: null,
      leadTimes: [],
      leadTimesLoaded: false,
      tooltip1: false,
      openingDistributionCenter: false,
      players: [],
      distributionCenter: 0,
      distributionCenterId: 0,
      ownedDcTypeToTeamCenterId: {},
      teamDistributionCentersRaw: [],
      editingExistingDc: false,
      distributionCentersInfo: [],
      // Per-product inventory allocations for the currently-viewed
      // distribution center. Keyed by product_id, value is the raw
      // digit string in the input field. UI-only for now; partner/
      // allocate submit fires via the Partner button below.
      allocations: {},
      // Hover-only state for the on-map DC tooltips. Kept separate from
      // activeDistributionCenter (which drives the right-side panel)
      // so the panel's title and lead-time table don't shift when the
      // user moves their mouse onto a different DC marker.
      hoveredDistributionCenter: 0,
      hoveredDistribution: null,
      // Heads Up confirmation for the Partner with Distributor button.
      showPartnerConfirmation: false,
      // Confirmation popup for Cancel Agreement on the Edit panel.
      showCancelAgreementConfirmation: false,
      // Populated when the user tries to allocate more than Max Allocation
      // for one or more products. Array of { name, requested, available }.
      allocationValidationError: null,
      tooltipCustomerName: null,
      tooltipCustomerDemand: null,
      customerDemands: [],
      showChangeLocationAlert: false,
      movingDistributionCenter: false,
      isPreChecked: false,
      successMessage: null,
      isInfoAlertVisible: false,
      infoAlertTitle: '',
      infoAlertText: '',
      selectDistributionCenterFacilityPopup: false,
      showDeselectLocationAlert: false,
      inventory_balances: [],
      inventory_allocations: [],
      metrics_report: null,
      prior_round_cost_per_unit: null,
      supply_chain_assets: [],
      machine_depreciations: [],
      selling_price_factors: [],
      price_forecasts: [],
      team_products: [],
      max_allowed_matrix: [],
      shipping_batch_size: 0,
      showMakeDecisionsModal: false,
      showManageProductionPage: false,
      // First-time coaching popup after the team's first machine
      // purchase in Round 1. See handleFirstMachineBought below.
      firstDecisionModalOpen: false,
      // First-time coaching popup after the team's first production
      // decision in Round 2 — nudges them toward the newly-available
      // Distribution Center decisions. See handleFirstProductionInRound2.
      firstDistributionModalOpen: false,
      // Product id whose "delete production" confirmation is open in
      // the Inventory Management table. null when no confirmation is
      // showing. See requestDeleteProduction / confirmDeleteProduction.
      deleteProductionProductId: null,
      // Dev-only map calibration overlay. Activated by `?devmap=1` URL
      // param. Clicking on the map logs and displays the x/y so dot
      // positions can be hand-tuned. Not visible to normal users.
      devMapMode: (() => {
        try {
          return new URLSearchParams(window.location.search).get('devmap') === '1';
        } catch (e) {
          return false;
        }
      })(),
      devMapLastClick: null
    };

    this.eventemitter = EventEmitter.getInstance();
  }

  showInfoAlert = (infoToShow) => {
    let title, text;
    if (infoToShow === 'Facility') {
      title = 'Facility';
      text = 'Refers to the building where the image sensors are manufactured. There’s only 1 facility.';
    } else if (infoToShow === 'Distribution Center') {
      title = 'Distribution Center';
      text = 'Refers to the building used to store, manage, and ship goods closer to customers.';
    } else if (infoToShow === 'Production Capacity Utilization') {
      title = 'Production Capacity Utilization';
      text = (
        <div>
          <p style={{ margin: '0 0 12px' }}>
            Measures how much of your plant’s annual production capacity you’re actually using.
          </p>
          <p style={{ margin: '0 0 12px' }}>
            This can stay below 100% even when you’re producing at max. If your product launches later than January 1, you have fewer months to produce, which caps your annual output.
          </p>
          <p style={{ margin: 0 }}>
            Check your product’s launch date on the Product Management decisions page.
          </p>
        </div>
      );
    }

    this.setState({
      isInfoAlertVisible: true,
      infoAlertTitle: title,
      infoAlertText: text
    });
  };

  hideInfoAlert = () => {
    this.setState({
      isInfoAlertVisible: false
    });
  };

  showSuccessMessage = successMessage => {
    this.setState({
      successMessage,
    }, () => {
      this.hideSuccessMessage();
    });
  }

  hideSuccessMessage = () => {
    setTimeout(() => {
      this.setState({
        successMessage: null,
      });
    }, 5000);
  }

  showCustomerTooltip = tooltipCustomerName => () => {
    const { customerDemands } = this.state;
    const customerDemand = customerDemands.find(i => Number(i.customer) === Number(tooltipCustomerName));
    const tooltipCustomerDemand = customerDemand ? numberFormat(Number(customerDemand.demand)) : 0;

    this.setState({
      tooltipCustomerName,
      tooltipCustomerDemand,
    });
  }

  showChangeLocationAlert = () => {
    this.setState({
      showChangeLocationAlert: true,
    });
  }

  hideChangeLocationAlert = () => {
    this.setState({
      showChangeLocationAlert: false,
    });
  }

  showDeselectLocationAlert = () => {
    this.setState({
      showDeselectLocationAlert: true,
    });
  }

  hideDeselectLocationAlert = () => {
    this.setState({
      showDeselectLocationAlert: false,
    });
  }

  hideCustomerTooltip = () => {
    this.setState({
      tooltipCustomerName: null,
      tooltipCustomerDemand: null,
    });
  }

  showTooltip1 = () => {
    this.setState({
      tooltip1: true,
    });
  }

  hideTooltip1 = () => {
    this.setState({
      tooltip1: false,
    });
  }

  showSelectDistributionCenterFacilityPopup = () => {
    this.setState({
      selectDistributionCenterFacilityPopup: true,
    });
  }

  hideSelectDistributionCenterFacilityPopup = () => {
    this.setState({
      selectDistributionCenterFacilityPopup: false,
    });
  }

  setPopupRef = ref => {
    this.setState({
      facilityPopup: ref,
    });
  }

  showDistributionCenters = () => {
    // Open the side panel AND immediately put the map into the DC
    // selection mode so the 3 glowing markers appear right away —
    // there's no longer a separate "Select a Location" button.
    this.setState({
      showDistributionCenters: true,
      canSelectDistributionCenters: true,
      selectDistributionCenterFacilityPopup: false,
      activeDistributionCenter: 0,
      distribution: null,
      leadTimes: [],
      leadTimesLoaded: false,
    });
  }

  hideDistributionCenters = () => {
    // Closing the panel returns the map to its normal customer-tooltip
    // mode and clears any in-progress DC selection.
    this.setState({
      showDistributionCenters: false,
      canSelectDistributionCenters: false,
      selectDistributionCenterFacilityPopup: false,
      activeDistributionCenter: 0,
      distribution: null,
      leadTimes: [],
      leadTimesLoaded: false,
    });
  }

  cancelDistributionCenter = () => {
    this.setState({
      activeDistributionCenter: 0,
      distribution: null,
      leadTimes: [],
      leadTimesLoaded: false,
      editingExistingDc: false,
      allocations: {},
    });
  }

  // Edit flow for an already-owned DC. Opens the right-side panel with
  // the same lead-time table + per-product inputs as the new-partnership
  // flow, but pre-fills inputs from inventory_allocations and switches
  // the action buttons to Update / Cancel Agreement / Cancel.
  editDistributionCenter = (dcType) => () => {
    const { distributionCentersInfo, inventory_allocations, ownedDcTypeToTeamCenterId } = this.state;
    const distribution = distributionCentersInfo.find(i => Number(i.type) === dcType) || null;
    if (!distribution) return;
    const teamCenterId = ownedDcTypeToTeamCenterId[dcType];

    const prefill = {};
    (inventory_allocations || [])
      .filter(a => Number(a.team_distribution_center) === Number(teamCenterId))
      .forEach(a => { prefill[a.product] = String(a.units); });

    getRequest(`${process.env.REACT_APP_API_URL}v2/distributions/lead-times/`)
      .then(res => {
        const leadTimes = res.body.results.filter(i => Number(i.distribution_center) === dcType);
        this.setState({
          activeDistributionCenter: dcType,
          distribution,
          leadTimes,
          leadTimesLoaded: true,
          allocations: prefill,
          editingExistingDc: true,
          hoveredDistributionCenter: 0,
          hoveredDistribution: null,
        });
      })
      .catch(err => { });
  }

  // Update Allocation button on the Edit panel. Skips Call 1 (POST
  // team-centers) since the team-center already exists, and just PUTs
  // the new allocations array.
  updateAllocation = () => {
    const { distribution, players, ownedDcTypeToTeamCenterId, activeDistributionCenter } = this.state;
    const { currentRound, rounds } = this.props;
    if (!distribution) return;

    const round = rounds.find(i => Number(i.number) === Number(currentRound));
    const roundId = round ? Number(round.id) : 0;
    const userId = Number(Auth.getUserId());
    const teamId = Number(Auth.getTeamId());
    const player = players.find(i => Number(i.user.id) === userId);
    const playerId = player ? Number(player.id) : 0;
    const teamCenterId = ownedDcTypeToTeamCenterId[activeDistributionCenter];

    this.setState({ openingDistributionCenter: true });
    this.submitAllocations(teamCenterId, teamId, roundId, playerId, { includeZeros: true })
      .then(() => {
        this.setState({
          activeDistributionCenter: 0,
          distribution: null,
          leadTimes: [],
          leadTimesLoaded: false,
          openingDistributionCenter: false,
          editingExistingDc: false,
          allocations: {},
        }, () => {
          this.fetchData();
        });
      })
      .catch(err => {
        this.setState({ openingDistributionCenter: false });
      });
  }

  // Cancel Agreement on the Edit panel. Pins the team-center id to the
  // one being edited (so multi-DC teams sell the right record) and opens
  // the confirmation popup.
  cancelAgreement = () => {
    const { activeDistributionCenter, ownedDcTypeToTeamCenterId } = this.state;
    const teamCenterId = ownedDcTypeToTeamCenterId[activeDistributionCenter];
    if (!teamCenterId) return;
    this.setState({
      distributionCenterId: teamCenterId,
      showCancelAgreementConfirmation: true,
    });
  }

  hideCancelAgreementConfirmation = () => {
    this.setState({ showCancelAgreementConfirmation: false });
  }

  confirmCancelAgreement = () => {
    const { distributionCenterId, teamDistributionCentersRaw, currentRound } = this.state;
    const { rounds } = this.props;
    if (!distributionCenterId) {
      this.setState({ showCancelAgreementConfirmation: false });
      return;
    }
    this.setState({
      showCancelAgreementConfirmation: false,
      openingDistributionCenter: true,
    });

    // Same-round cancels are a true undo (no breakage fee, no audit trail
    // needed) so the backend wants the record gone via DELETE. Prior-round
    // cancels keep the record around for accounting and use the sell/ verb.
    const round = rounds.find(i => Number(i.number) === Number(currentRound));
    const currentRoundId = round ? Number(round.id) : 0;
    const tc = (teamDistributionCentersRaw || [])
      .find(t => Number(t.id) === Number(distributionCenterId));
    const purchasedThisRound = tc && Number(tc.round) === currentRoundId;

    const apiCall = purchasedThisRound
      ? deleteRequest(`${process.env.REACT_APP_API_URL}v2/distributions/team-centers/${distributionCenterId}/`)
      : postRequest(`${process.env.REACT_APP_API_URL}v2/distributions/team-centers/${distributionCenterId}/sell/`);

    apiCall
      .then(() => {
        // Immediately drop the canceled DC from the owned-map so the
        // glowing "select me" marker re-appears without waiting for
        // fetchData to round-trip. Also force the panel back into
        // selection mode in case any of these flags drifted false.
        const canceledDcType = this.state.activeDistributionCenter;
        const nextOwned = { ...(this.state.ownedDcTypeToTeamCenterId || {}) };
        delete nextOwned[canceledDcType];
        this.setState({
          activeDistributionCenter: 0,
          distribution: null,
          leadTimes: [],
          leadTimesLoaded: false,
          editingExistingDc: false,
          allocations: {},
          openingDistributionCenter: false,
          showDistributionCenters: true,
          canSelectDistributionCenters: true,
          ownedDcTypeToTeamCenterId: nextOwned,
        }, () => {
          this.showSuccessMessage((
            <Fragment>
              <b>Agreement Voided</b><br />
              Your partnership with this distribution center has been canceled.
            </Fragment>
          ));
          this.fetchData();
        });
      })
      .catch(() => {
        this.setState({ openingDistributionCenter: false });
      });
  }

  unselectDistributionCenter = () => {
    this.setState({
      activeDistributionCenter: 0,
      distribution: null,
      selectDistributionCenterFacilityPopup: false
    });
  }

  // Hover-driven DC tooltip:
  //   onMouseEnter on marker  → hoverDistributionCenter(N)   (show tooltip)
  //   onMouseLeave on marker  → unhoverDistributionCenter    (queue close)
  //   onMouseEnter on tooltip → cancelDistributionCenterUnhover (stay open)
  //   onMouseLeave on tooltip → unhoverDistributionCenter    (close after delay)
  // The 400ms close delay lets the user move from the marker into the
  // tooltip without it disappearing in between.
  hoverDistributionCenter = (n) => () => {
    if (this._dcCloseTimer) {
      clearTimeout(this._dcCloseTimer);
      this._dcCloseTimer = null;
    }
    const { distributionCentersInfo } = this.state;
    const hoveredDistribution = distributionCentersInfo.find(i => Number(i.type) === n) || null;
    this.setState({
      hoveredDistributionCenter: n,
      hoveredDistribution,
    });
  };

  cancelDistributionCenterUnhover = () => {
    if (this._dcCloseTimer) {
      clearTimeout(this._dcCloseTimer);
      this._dcCloseTimer = null;
    }
  };

  unhoverDistributionCenter = () => {
    if (this._dcCloseTimer) clearTimeout(this._dcCloseTimer);
    this._dcCloseTimer = setTimeout(() => {
      if (!this._isMounted) return;
      // Only the hover (tooltip) state is cleared here — the panel
      // continues to display whatever DC the user clicked View Details
      // on, so its name and lead-time table don't disappear when the
      // mouse moves off the marker.
      this.setState({
        hoveredDistributionCenter: 0,
        hoveredDistribution: null,
      });
    }, 400);
  };

  // Per-product allocation input handler. Strips non-digits and stores
  // the cleaned value under the product_id key.
  setAllocation = (productId) => (e) => {
    const raw = (e.target.value || '').replace(/[^0-9]/g, '');
    this.setState({
      allocations: { ...this.state.allocations, [productId]: raw },
    });
  };

  // Heads Up confirmation flow for Partner with Distributor.
  showPartnerConfirmation = () => {
    // Validate every allocation against its per-product Max Allocation
    // before showing the confirmation dialog. Uses the same available =
    // available_for_sale - allocated_elsewhere formula rendered next to
    // each input (see the Allocate Inventory panel), so the ceiling
    // matches exactly what the user sees.
    const {
      products,
      allocations,
      inventory_allocations,
      editingExistingDc,
      ownedDcTypeToTeamCenterId,
      activeDistributionCenter,
    } = this.state;
    const currentTcId = editingExistingDc
      ? ownedDcTypeToTeamCenterId[activeDistributionCenter]
      : null;
    const overages = [];
    let totalRequested = 0;
    (products || []).forEach(product => {
      const productId = product.product_id;
      const allocatedElsewhere = (inventory_allocations || [])
        .filter(a => Number(a.product) === Number(productId))
        .filter(a => !currentTcId || Number(a.team_distribution_center) !== Number(currentTcId))
        .reduce((sum, a) => sum + (Number(a.units) || 0), 0);
      const available = Math.max(
        0,
        Math.round((Number(product.available_for_sale) || 0) - allocatedElsewhere)
      );
      const requested = Number(allocations && allocations[productId]) || 0;
      totalRequested += requested;
      if (requested > available) {
        overages.push({ name: product.product_name, requested, available });
      }
    });
    if (overages.length) {
      this.setState({ allocationValidationError: { kind: 'overage', rows: overages } });
      return;
    }
    if (totalRequested === 0) {
      this.setState({ allocationValidationError: { kind: 'zero' } });
      return;
    }
    this.setState({ showPartnerConfirmation: true });
  };

  dismissAllocationValidationError = () => {
    this.setState({ allocationValidationError: null });
  };

  cancelPartnerConfirmation = () => {
    this.setState({ showPartnerConfirmation: false });
  };

  confirmPartnerConfirmation = () => {
    this.setState({ showPartnerConfirmation: false });
    this.openDistributionCenter({ forceNew: true });
  };

  selectDistributionCenter = activeDistributionCenter => {
    console.log('inside selectDistributionCenter');
    const { distributionCentersInfo } = this.state;
    const distribution = distributionCentersInfo.find(i => Number(i.type) === activeDistributionCenter);

    this.setState({
      activeDistributionCenter,
      distribution,
    });
  }

  calculateDistance = () => {
    // Promote the currently-hovered DC into the panel's active state.
    // View Details is the user's explicit choice of which DC to inspect,
    // so we lock activeDistributionCenter/distribution to it here.
    const { hoveredDistributionCenter, hoveredDistribution } = this.state;
    if (!hoveredDistributionCenter) return;

    getRequest(`${process.env.REACT_APP_API_URL}v2/distributions/lead-times/`)
      .then(res => {
        const leadTimes = res.body.results.filter(i => Number(i.distribution_center) === hoveredDistributionCenter);

        // canSelectDistributionCenters stays true so the other 2 DC +
        // markers remain glowing/hoverable. The user can switch by
        // hovering another marker and clicking its View Details.
        this.setState({
          activeDistributionCenter: hoveredDistributionCenter,
          distribution: hoveredDistribution,
          leadTimes,
          leadTimesLoaded: true,
          allocations: {},
        });
      })
      .catch(err => { });
  }

  canSelectDistributionCenters = () => {
    this.setState({
      showDistributionCenters: false,
      canSelectDistributionCenters: true,
      selectDistributionCenterFacilityPopup: false,
      activeDistributionCenter: 0,
      distribution: null,
      leadTimes: [],
      leadTimesLoaded: false,
    });
  }

  reloadRole = () => {
    const role = Auth.getRole();
    const hasAccess = role === "CEO" || role === "OP";
    const isOwnRole = role === "OP";

    this.setState({
      hasAccess,
      isOwnRole
    });
  };

  componentWillReceiveProps(nextProps) {
    if (
      this.state.roundInUrl !== nextProps.roundInUrl ||
      this.state.currentRound !== nextProps.currentRound ||
      (this.state.rounds.length === 0 && nextProps.rounds.length !== 0)
    ) {
      this.setState(
        {
          roundInUrl: nextProps.roundInUrl,
          currentRound: nextProps.currentRound,
          rounds: nextProps.rounds
        },
        () => {
          this.fetchData();
          this.reloadRole();
        }
      );
    }
  }

  componentDidMount() {
    this._isMounted = true;
    this.fetchData();
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (this._dcCloseTimer) clearTimeout(this._dcCloseTimer);
  }

  fetchData = (showWarnings) => {
    const { rounds } = this.props;
    const { roundInUrl, currentRound } = this.state;
    const round_number = roundInUrl !== null ? roundInUrl : currentRound;

    Promise.all([
      fetchTeamDecisions(round_number, 'operations'),
      fetchTeamStatus(round_number),
      fetchAllStaticData(round_number, 'operations'),
    ])
      .then(([decisionsData, statusData, staticData]) => {
        if (!this._isMounted) return;

        if (showWarnings) {
          showWarnings(decisionsData);
        }

        const {
          operations_decisions,
          team_machines,
          factories,
          distributionCenter: distributionCentersRaw,
          distributionCentersInfo: distributionCentersInfoRaw,
          inventory_balances,
          inventory_allocations,
          dc_lease_schedules,
          metrics_report,
          machine_depreciations,
          selling_price_factors,
          price_forecasts,
          products: team_products,
          max_allowed_matrix,
          shipping_batch_size,
        } = decisionsData;
        const { submission_data } = statusData;

        const { products, team } = operations_decisions;
        const players = Teams.players() || [];

        const teamId = Number(Auth.getTeamId());

        const previousRoundsIds = rounds.filter(i => Number(i.number) >= 2 && Number(i.number) <= Number(round_number)).map(i => i.id);

        const teamDistributionCentersRaw = (distributionCentersRaw || [])
          .filter(i => Number(i.team) === teamId && previousRoundsIds.includes(Number(i.round)));
        const distributionCentersFiltered = orderBy(
          teamDistributionCentersRaw.filter(i => !i.sold_in_round),
          'number',
          ['desc']
        );
        const distributionCenterObj = distributionCentersFiltered.length > 0 ? distributionCentersFiltered[0] : null;
        const distributionCenter = distributionCenterObj ? Number(distributionCenterObj.distribution_center) : 0;
        const distributionCenterId = distributionCenterObj ? Number(distributionCenterObj.id) : 0;

        // Multi-DC ownership lookup: map of DC marker number -> team-center
        // id. Each owned team-center references a catalog DC via FK; the
        // catalog id happens to equal the map marker number (1=Toledo,
        // 2=Little Rock, 3=Portland), so we key directly on it.
        // sold_in_round-bearing records are excluded so canceled DCs aren't
        // shown as owned.
        const ownedDcTypeToTeamCenterId = {};
        distributionCentersFiltered.forEach(tc => {
          const dcType = Number(tc.distribution_center);
          if (dcType > 0) ownedDcTypeToTeamCenterId[dcType] = Number(tc.id);
        });

        const { overall_unit_utilization, prior_round_cost_per_unit, supply_chain_assets } = team;

        // Operation Spending for the round =
        //   abs(production_costs)
        //   + Σ abs(machines[].machine_costs)
        //   + Σ abs(dc_lease_schedules[].cash_payment)
        //   + abs(facility_costs)
        //
        // Every term follows the backend's negative-outflow convention,
        // so we take the absolute value of each contribution before
        // summing. Otherwise a negative field silently cancels the
        // headline against the other costs.
        // Operation Spending for the round — net cash view:
        //   abs(production_costs)
        //   + Σ abs(machines[].machine_costs)
        //   + Σ abs(dc_lease_schedules[].cash_payment)
        //   + abs(facility_costs)
        //   − capital_exp_sales   ← proceeds in from selling a machine
        //
        // BE convention: outflow fields come in negative, so each
        // additive term is Math.abs()'d. capital_exp_sales arrives
        // positive and is subtracted directly to net the cash out of
        // the spending headline.
        const machinesCosts = (team.machines || [])
          .reduce((s, m) => s + Math.abs(Number(m.machine_costs) || 0), 0);
        const dcCashPayment = (dc_lease_schedules || [])
          .reduce((s, l) => s + Math.abs(Number(l.cash_payment) || 0), 0);
        const productionCosts = Math.abs(Number(team.production_costs) || 0);
        const facilityCosts = Math.abs(Number(team.facility_costs) || 0);
        const capitalExpSales = Math.max(0, Number(team.capital_exp_sales) || 0);
        const operation_spending =
          productionCosts
          + machinesCosts
          + dcCashPayment
          + facilityCosts
          - capitalExpSales;

        // Breakdown for the Operation Spending hover tooltip. Each row
        // carries a `kind` the render path uses for coloring —
        // "cost" rows render red, "receipt" rows render black. Order
        // is explicit so the "Cash received from production line sale"
        // row always sits directly beneath "Production Line Costs"
        // (previously labeled "Machine Costs").
        const operationSpendingBreakdown = [
          { label: 'Production Costs (excl. depreciation)', amount: productionCosts, kind: 'cost' },
          { label: 'Production Line Costs', amount: machinesCosts, kind: 'cost' },
          { label: 'Cash received from production line sale', amount: capitalExpSales, kind: 'receipt' },
          { label: 'Distribution Center Costs', amount: dcCashPayment, kind: 'cost' },
          { label: 'Facility Costs', amount: facilityCosts, kind: 'cost' },
        ].filter(item => item.amount > 0);

        const distributionCentersInfo = distributionCentersInfoRaw || [];

        // BE pre-filters customer_demand to the requested round on the
        // operations scope, so the per-row round_number filter FE used
        // to run is no longer needed.
        const customerDemands = staticData.customerDemand || [];

        const isPreChecked = submission_data.op && submission_data.op.date !== 'N/A';

        this.setState({
          products,
          submission_data,
          team_machines,
          overall_unit_utilization,
          operation_spending,
          operationSpendingBreakdown,
          factories,
          submitDecisionsLoading: false,
          loaded: true,
          players,
          distributionCenter,
          distributionCenterId,
          ownedDcTypeToTeamCenterId,
          teamDistributionCentersRaw,
          distributionCentersInfo,
          customerDemands,
          movingDistributionCenter: false,
          isPreChecked,
          inventory_balances: inventory_balances || [],
          inventory_allocations: inventory_allocations || [],
          metrics_report: metrics_report || null,
          prior_round_cost_per_unit: prior_round_cost_per_unit != null
            ? Number(prior_round_cost_per_unit)
            : null,
          supply_chain_assets: supply_chain_assets || [],
          machine_depreciations: machine_depreciations || [],
          selling_price_factors: selling_price_factors || [],
          price_forecasts: price_forecasts || [],
          team_products: team_products || [],
          max_allowed_matrix: max_allowed_matrix || [],
          shipping_batch_size: shipping_batch_size || 0,
        });
      })
      .catch(err => {
        logError(err, "OperationsDecisions", "fetchData");
      });
  };

  submitDecisions = () => {
    this.setState({
      submitDecisionsLoading: true
    });

    submitDecisions("operations", this.state.roundInUrl || this.state.currentRound, (showWarnings) => {
      this.fetchData(showWarnings);
    });
  };

  get showActionButtons() {
    const { hasAccess, roundInUrl, currentRound, rounds } = this.state;
    const { roundShouldBeFinished } = this.props;

    if (hasAccess === false) {
      return false;
    }

    if (roundShouldBeFinished === true) {
      return false;
    }

    if (roundInUrl !== null && roundInUrl !== currentRound) {
      return false;
    }

    const round = rounds.find(i => i.number === currentRound);

    if (!round) {
      return false;
    }

    return round.is_started === true && round.is_finished === false;
  }

  createFactory = () => {
    return postRequest(`${process.env.REACT_APP_API_URL}team/factories/`).send({
      factory: 1
    });
  };

  selectFacilityPopupShown = () => {
    this.setState({
      selectFacilityPopupShown: true,
    });
  }

  hideFacilityPopupShown = () => {
    this.setState({
      selectFacilityPopupShown: false,
    });
  }

  checkDistributionCenter = () => {
    const { distributionCenter } = this.state;

    if (distributionCenter > 0) {
      this.showChangeLocationAlert();
    } else {
      this.openDistributionCenter();
    }
  }

  openDistributionCenter = ({ forceNew = false } = {}) => {
    const { distribution, players, distributionCenterId } = this.state;
    const { currentRound, rounds } = this.props;

    const round = rounds.find(i => Number(i.number) === Number(currentRound));
    const roundId = round ? Number(round.id) : 0;
    const userId = Number(Auth.getUserId());
    const teamId = Number(Auth.getTeamId());
    const player = players.find(i => Number(i.user.id) === userId);
    const playerId = player ? Number(player.id) : 0;

    if (distribution) {
      this.setState({
        openingDistributionCenter: true,
        showChangeLocationAlert: false,
      });

      if (!forceNew && distributionCenterId > 0) {
        patchRequest(`${process.env.REACT_APP_API_URL}v2/distributions/team-centers/${distributionCenterId}/`)
          .send({
            distribution_center: distribution.id,
          })
          .then(res => this.submitAllocations(distributionCenterId, teamId, roundId, playerId))
          .then(() => {
            this.setState({
              movingDistributionCenter: true,
              activeDistributionCenter: 0,
              distribution: null,
              leadTimes: [],
              leadTimesLoaded: false,
              openingDistributionCenter: false,
            }, () => {
              this.fetchData();
            });
          })
          .catch(err => { });
      } else {
        // Re-partner via unsell/ if this DC was canceled in the CURRENT
        // round (and originally purchased in a prior round — same-round
        // cancels DELETE the record, so any sold_in_round record we find
        // here is guaranteed to be a prior-round purchase). Otherwise
        // it's a regular new partnership.
        const { teamDistributionCentersRaw } = this.state;
        const soldThisRoundTc = (teamDistributionCentersRaw || []).find(t =>
          Number(t.distribution_center) === Number(distribution.id)
          && Number(t.sold_in_round) === roundId
        );

        const partnerCall = soldThisRoundTc
          ? postRequest(`${process.env.REACT_APP_API_URL}v2/distributions/team-centers/${soldThisRoundTc.id}/unsell/`)
          : postRequest(`${process.env.REACT_APP_API_URL}v2/distributions/team-centers/`)
              .send({
                distribution_center: distribution.id,
                round: roundId,
                team: teamId,
                player: playerId,
              });

        partnerCall
          .then(res => {
            const newTeamCenterId = soldThisRoundTc
              ? Number(soldThisRoundTc.id)
              : (res && res.body ? Number(res.body.id) : 0);
            return this.submitAllocations(newTeamCenterId, teamId, roundId, playerId);
          })
          .then(() => {
            this.setState({
              activeDistributionCenter: 0,
              distribution: null,
              leadTimes: [],
              leadTimesLoaded: false,
              openingDistributionCenter: false,
            }, () => {
              this.fetchData();
            });
          })
          .catch(err => { });
      }
    }
  }

  // Builds the per-product allocation payload from this.state.allocations
  // and PUTs it to set_allocation/. By default skips zero-unit items (so
  // a partner-only confirm with all-zero inputs doesn't hit the endpoint).
  // Pass includeZeros=true from the Edit flow so explicit clears
  // (e.g. 150,000 -> 0) still reach the backend.
  submitAllocations = (teamCenterId, teamId, roundId, playerId, { includeZeros = false } = {}) => {
    const { allocations } = this.state;
    if (!teamCenterId) return Promise.resolve();

    const items = Object.keys(allocations || {})
      .map(productId => ({
        product: Number(productId),
        units: Number(allocations[productId]) || 0,
      }))
      .filter(a => includeZeros || a.units > 0);

    if (items.length === 0) return Promise.resolve();

    return putRequest(`${process.env.REACT_APP_API_URL}v2/distributions/team-origin-inventories/set_allocation/`)
      .send({
        team: teamId,
        round: roundId,
        player: playerId,
        team_distribution_center: Number(teamCenterId),
        allocations: items,
      });
  }

  deleteDistributionCenter = () => {
    const { distributionCenterId } = this.state;

    this.setState({
      openingDistributionCenter: true,
      showDeselectLocationAlert: false,
      canSelectDistributionCenters: false
    });
    deleteRequest(`${process.env.REACT_APP_API_URL}v2/distributions/team-centers/${distributionCenterId}`)
      .then(res => {
        this.setState({
          activeDistributionCenter: 0,
          distribution: null,
          leadTimes: [],
          leadTimesLoaded: false,
          openingDistributionCenter: false,
        }, () => {
          this.fetchData();
        });
      })
      .catch(err => { });
  }

  onCreateFactory = () => {
    const { tourMode } = this.props;

    if (tourMode === true) {
      return;
    }

    this.setState({
      loadingFactory: true,
      selectFacilityPopupShown: false,
    });

    this.createFactory()
      .then(res => {
        this.showSuccessMessage((
          <Fragment>
            <b>Facility Selected Successfully</b><br />
            Note: This is the only production facility available and you need it to manufacture units.
          </Fragment>
        ));
        incrementUnacceptedDecisions("operations");
        this.setState(
          {
            loadingFactory: false
          },
          () => {
            this.fetchData();
          }
        );
      })
      .catch(err => {
        logError(err, "OperationsDecisions", "onCreateFactory");
      });
  };

  // Opens the redesigned Make Decisions overlay. If this is the first
  // time the team is reaching the Operations page (no facility row
  // exists yet), submit the facility selection silently before opening
  // — matches the old "Facility Selected" button behavior so the user
  // never has to click it explicitly.
  openMakeDecisionsModal = () => {
    const { tourMode } = this.props;
    if (tourMode === true) return;

    this.setState({ showMakeDecisionsModal: true });

    const { factories, loadingFactory } = this.state;
    if (factories.length === 0 && loadingFactory !== true) {
      this.onCreateFactory();
    }
  };

  closeMakeDecisionsModal = () => {
    this.setState({ showMakeDecisionsModal: false });
  };

  // Fired by BuyingMachines after the team's first successful machine
  // purchase in Round 1. Shows the coaching modal that reminds the
  // student they still need to make inventory decisions.
  handleFirstMachineBought = () => {
    this.setState({ firstDecisionModalOpen: true });
  };

  handleFirstDecisionClose = () => {
    this.setState({ firstDecisionModalOpen: false });
  };

  // CTA: close the popup and the machine-picker modal, then open the
  // Make Decisions overlay so the user sees the other operations
  // decisions they still need to make.
  handleFirstDecisionCta = () => {
    this.setState({
      firstDecisionModalOpen: false,
      showMakeDecisionsModal: true,
    });
    this.eventemitter.trigger('hide-buying-machines-modal');
  };

  // Fired by ManageProductionPage after the team's first successful
  // production decision in Round 2. Shows the coaching modal that
  // introduces Distribution Center decisions (newly unlocked in Rd 2).
  handleFirstProductionInRound2 = () => {
    this.setState({ firstDistributionModalOpen: true });
  };

  handleFirstDistributionClose = () => {
    this.setState({ firstDistributionModalOpen: false });
  };

  // CTA: close the popup and the Manage Production overlay, then open
  // the Distribution Center selection UI so the user lands directly on
  // their next decision.
  handleFirstDistributionCta = () => {
    this.setState({
      firstDistributionModalOpen: false,
      showManageProductionPage: false,
    });
    this.showDistributionCenters();
  };

  // Dev-only: capture a click on the map, log the relative x/y to the
  // console so it can be pasted into a MapDot. MapDot's x/y now anchor
  // the dot's CENTER (via CSS translate(-50%, -50%)), so the raw click
  // position is what you paste — no offset adjustment needed.
  handleDevMapClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = Math.round(e.clientX - rect.left);
    const y = Math.round(e.clientY - rect.top);
    // eslint-disable-next-line no-console
    console.log(`x={${x}} y={${y}}`);
    this.setState({ devMapLastClick: { x, y } });
  };

  pickMakeDecisionsOption = (option) => () => {
    this.closeMakeDecisionsModal();
    if (option === 'buy-sell-machines') {
      this.eventemitter.trigger('show-buying-machines-modal');
    } else if (option === 'produce-units') {
      this.setState({ showManageProductionPage: true });
    } else if (option === 'distribution-center') {
      this.showDistributionCenters();
    }
  };

  closeManageProductionPage = () => {
    this.setState({ showManageProductionPage: false });
  };

  // ----- Lead-row KPI getters -----

  get totalAvailableForSale() {
    const { inventory_balances } = this.state;
    return (inventory_balances || []).reduce(
      (sum, row) => sum + (Number(row.available_for_sale) || 0),
      0
    );
  }

  get avgCostPerUnit() {
    const { inventory_balances, products } = this.state;

    // Primary: value of ending inventory / units in ending inventory
    // (post-sim). Represents the cost of what's sitting in the
    // warehouse after sales have run.
    const ending = (inventory_balances || []).reduce(
      (acc, row) => {
        acc.costs += Number(row.ending_inventory_costs) || 0;
        acc.units += Number(row.ending_inventory) || 0;
        return acc;
      },
      { costs: 0, units: 0 }
    );
    if (ending.units > 0) return ending.costs / ending.units;

    // Fallback (pre-sim, ending_inventory not yet populated): weight
    // per-product cost_per_unit by available_for_sale — same source
    // the Inventory Management table shows. Prevents the KPI from
    // reading $0.00 during a round that hasn't been simulated.
    const avail = (products || []).reduce(
      (acc, p) => {
        const units = Number(p.available_for_sale) || 0;
        const cpu = Number(p.cost_per_unit) || 0;
        acc.costs += cpu * units;
        acc.units += units;
        return acc;
      },
      { costs: 0, units: 0 }
    );
    return avail.units > 0 ? avail.costs / avail.units : 0;
  }

  // Returns null on round 1 or when the backend hasn't yet supplied a
  // prior-round value (avoids showing a misleading "vs last year" line
  // when there's nothing meaningful to compare against).
  get costPerUnitDelta() {
    const { roundInUrl, currentRound, prior_round_cost_per_unit } = this.state;
    const viewedRound = roundInUrl !== null ? roundInUrl : currentRound;
    if (Number(viewedRound) <= 1) return null;
    if (prior_round_cost_per_unit == null || prior_round_cost_per_unit <= 0) return null;
    const delta = this.avgCostPerUnit - prior_round_cost_per_unit;
    return { delta, up: delta > 0 };
  }

  // Inventory Management trash-icon handlers. Two-step flow: click
  // the trash next to the product name -> WarningAlert confirms ->
  // reuses onRemoveOperation to DELETE the product_manufactures row
  // for that product (same delete path used by ProduceProduct).
  requestDeleteProduction = (productId) => (e) => {
    if (e && e.preventDefault) e.preventDefault();
    this.setState({ deleteProductionProductId: productId });
  };

  cancelDeleteProduction = () => {
    this.setState({ deleteProductionProductId: null });
  };

  confirmDeleteProduction = () => {
    const productId = this.state.deleteProductionProductId;
    this.setState({ deleteProductionProductId: null });
    if (productId != null) {
      this.onRemoveOperation({ preventDefault: () => {} }, productId);
    }
  };

  onRemoveOperation = (e, product_id, callback) => {
    e.preventDefault();

    getRequest(`${process.env.REACT_APP_API_URL}team/product_manufactures/`)
      .then(res => {
        const obj = res.body.find(i => i.product === product_id);

        if (!obj) {
          return;
        }

        deleteRequest(
          `${process.env.REACT_APP_API_URL}team/product_manufactures/${obj.id}/`
        )
          .then(res => {
            decrementUnacceptedDecisions("operations");
            this.fetchData();
            if (callback) {
              callback();
            }
          })
          .catch(err => {
            logError(err, "OperationsDecisions", "onRemoveOperation");
          });
      })
      .catch(err => {
        logError(err, "OperationsDecisions", "onRemoveOperation");
      });
  };

  render() {
    // Lock the page only when no round has ever been started.
    // Does not fire for finished games (see ceo-decisions.js for the
    // full explanation).
    const hasEverStarted = (this.props.rounds || []).some(
      r => r && r.is_started === true
    );
    if (this.props.rounds_loaded && !hasEverStarted) {
      return <RoundNotStartedGate />;
    }

    const showActionButtons = this.showActionButtons;
    const {
      products,
      isOwnRole,
      loaded,
      submission_data,
      submitDecisionsLoading,
      loadingFactory,
      currentRound,
      rounds,
      overall_unit_utilization,
      operation_spending,
      operationSpendingBreakdown,
      showOpsSpendingTooltip,
      hoveredNotReleasedProductId,
      factories,
      selectFacilityPopupShown,
      facilityPopup,
      showDistributionCenters,
      canSelectDistributionCenters,
      activeDistributionCenter,
      distribution,
      leadTimes,
      leadTimesLoaded,
      tooltip1,
      openingDistributionCenter,
      distributionCenter,
      distributionCentersInfo,
      tooltipCustomerName,
      tooltipCustomerDemand,
      showChangeLocationAlert,
      movingDistributionCenter,
      isPreChecked,
      team_machines,
      successMessage,
      isInfoAlertVisible,
      infoAlertTitle,
      infoAlertText,
      selectDistributionCenterFacilityPopup,
      showDeselectLocationAlert,
      allocations,
      inventory_allocations,
      metrics_report,
      ownedDcTypeToTeamCenterId,
      editingExistingDc,
      hoveredDistributionCenter,
      hoveredDistribution,
      showPartnerConfirmation,
      showCancelAgreementConfirmation,
      allocationValidationError,
      supply_chain_assets,
      machine_depreciations,
      selling_price_factors,
      price_forecasts,
      team_products,
      max_allowed_matrix,
      shipping_batch_size
    } = this.state;
    const { tourMode, location, router, currentRound: round, roundInUrl } = this.props;
    const unitUtilizationFormatted = decimalsRound(
      overall_unit_utilization * 100,
      0
    );
    const temporaryUser = Auth.getTemporaryUser();
    const showCustomerTooltip = tooltipCustomerName !== null && tooltipCustomerDemand !== null;

    // Aggregates an owned DC's committed allocations for tooltip display.
    // Returns total units and total shipping_cost across products. Both
    // are 0 when the DC has no commits yet.
    const dcOwnedStats = (dcType) => {
      const tcId = ownedDcTypeToTeamCenterId[dcType];
      if (!tcId) return { units: 0, shipping: 0 };
      const allocs = (inventory_allocations || []).filter(
        a => Number(a.team_distribution_center) === Number(tcId)
      );
      return {
        units: allocs.reduce((s, a) => s + (Number(a.units) || 0), 0),
        shipping: allocs.reduce((s, a) => s + (Number(a.shipping_cost) || 0), 0),
      };
    };

    return (
      <Styled.BodyWrapper>
        {isInfoAlertVisible && (
          <DecisionsAlert
            type="info"
            title={infoAlertTitle}
            message={infoAlertText}
            buttonText="Done"
            onHide={this.hideInfoAlert}
          />
        )}
        <SweetAlert
          show={showChangeLocationAlert}
          title="Change location?"
          text="You have already opened a distribution center. Continue changing to the new location?"
          confirmButtonText="Yes, Change Location"
          onConfirm={() => this.openDistributionCenter()}
          cancelButtonText="No, Keep Current Location"
          onCancel={this.hideChangeLocationAlert}
          showCancelButton={true}
        />
        <SweetAlert
          show={showDeselectLocationAlert}
          title="Are You Sure?"
          text="By choosing this option, you are deselecting the previously selected distribution center."
          confirmButtonText="Yes, Change Location"
          onConfirm={this.deleteDistributionCenter}
          cancelButtonText="No, Keep Current Location"
          onCancel={this.hideDeselectLocationAlert}
          showCancelButton={true}
        />
        <LastStepModal
          location={location}
          router={router}
          url={`/decisions/operations?round=${round}`}
        />
        <Styled.TitleWrapper>
          <Styled.Title id="product-marketing-decisions-title">
            Operations
            {isOwnRole && !temporaryUser && <RoleButtons type="operations" />}
          </Styled.Title>
          {showActionButtons === true && loaded === true && !temporaryUser && (
            <SubmitDecisionsButton
              id="operations-decision-submit-decisions"
              tooltipPlacement="bottom"
              data={submission_data.op}
              isLoading={submitDecisionsLoading}
              onClick={this.submitDecisions}
              buttonComponent={Styled.SubmitDecisionButton}
              isPreChecked={isPreChecked}
            />
          )}
        </Styled.TitleWrapper>
        <Styled.Subtitle>
          Manufacture image sensors and manage inventory levels &amp; locations.
        </Styled.Subtitle>
        {showActionButtons === true && !temporaryUser && !leadTimesLoaded && (
          <FinanceStyled.ManageButtonBar style={{ marginTop: 20 }}>
            <FinanceStyled.ManageButton
              onClick={this.openMakeDecisionsModal}
              disabled={loadingFactory === true}
            >
              {loadingFactory === true ? "Loading..." : "Make Decisions"}
            </FinanceStyled.ManageButton>
          </FinanceStyled.ManageButtonBar>
        )}
        {/* Sub-modals previously rendered inside ButtonsGroup. They
            self-listen for EventEmitter triggers, so mounting them here
            keeps the existing Buy/Sell Machine and Produce Units flows
            wired up without rendering the old button row. */}
        <BuyingMachines
          tourMode={tourMode}
          reloadData={this.fetchData}
          currentRound={currentRound}
          rounds={rounds}
          teamId={Teams.currentTeam().id}
          richTeamMachines={team_machines}
          machineDepreciations={machine_depreciations}
          sellingPriceFactors={selling_price_factors}
          onFirstMachineBought={this.handleFirstMachineBought}
        />
        <FirstDecisionModal
          open={this.state.firstDecisionModalOpen}
          title="Congrats on your first production line!"
          body="You can update this any time before the round deadline. Make sure to also make your inventory production decisions before the round ends."
          ctaLabel="View Other Decisions"
          onCta={this.handleFirstDecisionCta}
          onClose={this.handleFirstDecisionClose}
        />
        <ProduceProduct
          products={products}
          reloadData={this.fetchData}
          onRemoveOperation={this.onRemoveOperation}
          showSuccessMessage={this.showSuccessMessage}
          currentRound={currentRound}
        />
        {successMessage && <SuccessAlert
          message={successMessage}
        />}
        {loaded === true && (
          <div>
            <FinanceStyled.KpiRow cardCount={4}>
              <FinanceStyled.KpiCard>
                <FinanceStyled.KpiLabel>Available Units for Sale</FinanceStyled.KpiLabel>
                <FinanceStyled.KpiValue>
                  {Math.round(this.totalAvailableForSale).toLocaleString('en-US')}
                </FinanceStyled.KpiValue>
              </FinanceStyled.KpiCard>
              <FinanceStyled.KpiCard>
                <FinanceStyled.KpiLabel>Cost Per Unit</FinanceStyled.KpiLabel>
                <FinanceStyled.KpiValue>
                  ${this.avgCostPerUnit.toFixed(2)}
                </FinanceStyled.KpiValue>
                {this.costPerUnitDelta && (
                  <Styled.KpiDelta negative={this.costPerUnitDelta.up}>
                    {this.costPerUnitDelta.up ? '↑' : '↓'} ${Math.abs(this.costPerUnitDelta.delta).toFixed(2)} vs last year
                  </Styled.KpiDelta>
                )}
              </FinanceStyled.KpiCard>
              <FinanceStyled.KpiCard>
                <FinanceStyled.KpiLabel>
                  Production Capacity Utilization
                  <Styled.HelpIcon
                    src={IconTableHelp}
                    onClick={() => this.showInfoAlert('Production Capacity Utilization')}
                  />
                </FinanceStyled.KpiLabel>
                <FinanceStyled.KpiValue>{unitUtilizationFormatted}%</FinanceStyled.KpiValue>
              </FinanceStyled.KpiCard>
              <FinanceStyled.KpiCard
                onMouseEnter={() => this.setState({ showOpsSpendingTooltip: true })}
                onMouseLeave={() => this.setState({ showOpsSpendingTooltip: false })}
                style={{ position: 'relative' }}
              >
                <FinanceStyled.KpiLabel>Operation Spending</FinanceStyled.KpiLabel>
                <FinanceStyled.KpiValue style={{ color: '#C62828' }}>
                  ${Math.round(Math.abs(operation_spending)).toLocaleString('en-US')}
                </FinanceStyled.KpiValue>
                {showOpsSpendingTooltip && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    marginTop: 8,
                    background: '#fff',
                    border: '1px solid #D5D9DD',
                    borderRadius: 6,
                    boxShadow: '0 4px 12px rgba(0, 27, 59, 0.12)',
                    padding: '12px 16px',
                    minWidth: 280,
                    zIndex: 1000,
                    fontFamily: "'Mukta Vaani', Lato, sans-serif",
                    fontSize: 13,
                    color: 'rgba(0, 27, 59, 0.94)',
                  }}>
                    <div style={{
                      fontWeight: 600,
                      fontSize: 12,
                      letterSpacing: '0.5px',
                      textTransform: 'uppercase',
                      color: 'rgba(0, 27, 59, 0.6)',
                      marginBottom: 8,
                    }}>
                      Spending Breakdown
                    </div>
                    <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
                      {(operationSpendingBreakdown || []).map((item, i) => {
                        // Costs render red to match the KPI headline;
                        // cash receipts render in the default navy so
                        // the inflow visually separates from outflows.
                        const rowColor = item.kind === 'receipt'
                          ? 'rgba(0, 27, 59, 0.94)'
                          : '#C62828';
                        return (
                          <li key={`ops-spend-${i}`} style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            gap: 16,
                            marginBottom: 4,
                            color: rowColor,
                          }}>
                            <span>{item.label}</span>
                            <span style={{ fontWeight: 600 }}>
                              ${Math.round(item.amount).toLocaleString('en-US')}
                            </span>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}
              </FinanceStyled.KpiCard>
            </FinanceStyled.KpiRow>
            {showDistributionCenters && (
              <div style={{
                position: 'fixed',
                top: 0, left: 0, right: 0, bottom: 0,
                background: 'rgba(0, 0, 0, 0.45)',
                zIndex: 800,
              }} />
            )}
            <Styled.OpsLeadGrid>
              <Styled.OpsLeadGridMarket
                style={showDistributionCenters
                  ? { position: 'relative', zIndex: 900 }
                  : undefined}
              >
                <FinanceStyled.SectionCard>
                  <FinanceStyled.SectionHeader>
                    <FinanceStyled.SectionTitle>Market Information</FinanceStyled.SectionTitle>
                    <FinanceStyled.SectionSubtitle>
                      Locations of customers, production facility, and distribution centers.
                    </FinanceStyled.SectionSubtitle>
                  </FinanceStyled.SectionHeader>
                  {/* Off-screen ref anchor: DistributionCentersPopup uses
                      this element's offsetWidth to position its arrow and
                      popup. The old layout exposed the small overlay map as
                      the ref; the redesigned page no longer renders it, so
                      we keep an invisible 500px-wide sentinel so popup
                      positions stay stable. */}
                  {showDistributionCenters && (
                    <div
                      ref={this.setPopupRef}
                      style={{
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        width: '500px',
                        height: '1px',
                        visibility: 'hidden',
                        pointerEvents: 'none',
                      }}
                    />
                  )}
                  {movingDistributionCenter && (
                    <Styled.TopBanner>Moving distribution center...</Styled.TopBanner>
                  )}
                  <Styled.GoogleMap>
                {/*<GoogleMapReact
                  bootstrapURLKeys={{
                    key: process.env.REACT_APP_GOOGLE_MAP_API,
                  }}
                  defaultCenter={{
                    lat: 39.8097,
                    lng: -98.5556,
                  }}
                  defaultZoom={3}
                />*/}
                <img src={MapImage} alt="map" onClick={(canSelectDistributionCenters && activeDistributionCenter) || selectDistributionCenterFacilityPopup > 0 ? this.unselectDistributionCenter : null} />

                {canSelectDistributionCenters && !activeDistributionCenter && !leadTimesLoaded && (
                  <Styled.SelectDcCallout>
                    Select a Distribution Center
                  </Styled.SelectDcCallout>
                )}

                <Styled.MapDot
                  x={377}
                  y={274}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(1)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  1
                </Styled.MapDot>
                <Styled.MapDot
                  x={289}
                  y={262}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(2)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  2
                </Styled.MapDot>
                <Styled.MapDot
                  x={37}
                  y={105}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(3)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  3
                </Styled.MapDot>
                <Styled.MapDot
                  x={423}
                  y={147}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(4)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  4
                </Styled.MapDot>
                <Styled.MapDot
                  x={42}
                  y={203}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(5)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  5
                </Styled.MapDot>
                <Styled.MapDot
                  x={295}
                  y={223}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(6)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  6
                </Styled.MapDot>
                <Styled.MapDot
                  x={269}
                  y={188}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(7)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  7
                </Styled.MapDot>
                <Styled.MapDot
                  x={325}
                  y={212}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(8)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  8
                </Styled.MapDot>
                <Styled.MapDot
                  x={209}
                  y={178}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(9)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  9
                </Styled.MapDot>
                <Styled.MapDot
                  x={377}
                  y={122}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(10)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  10
                </Styled.MapDot>
                <Styled.MapDot
                  x={487}
                  y={134}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(11)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  11
                </Styled.MapDot>
                <Styled.MapDot
                  x={192}
                  y={233}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(12)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  12
                </Styled.MapDot>
                <Styled.MapDot
                  x={401}
                  y={198}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(13)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  13
                </Styled.MapDot>
                <Styled.MapDot
                  x={378}
                  y={224}
                  onMouseEnter={canSelectDistributionCenters || leadTimesLoaded ? null : this.showCustomerTooltip(14)}
                  onMouseLeave={canSelectDistributionCenters || leadTimesLoaded ? null : this.hideCustomerTooltip}
                >
                  14
                </Styled.MapDot>

                <Styled.Tooltip1
                  show={showCustomerTooltip}
                  top={showCustomerTooltip ? tooltipsPositions[tooltipCustomerName][1] : 0}
                  left={showCustomerTooltip ? tooltipsPositions[tooltipCustomerName][0] : 0}
                >
                  <Styled.TooltipTitle>
                    <span>{showCustomerTooltip ? tooltipCustomerName : ''}</span>
                    {showCustomerTooltip ? customersLocations[tooltipCustomerName] : ''}
                  </Styled.TooltipTitle>
                  <Styled.TooltipCost background="rgba(0, 27, 43, 0.02)">
                    Customer Name: <span>{showCustomerTooltip ? tooltipCustomerName : ''}</span>
                    <Styled.TooltipSpace />
                    Demand: <span>{showCustomerTooltip ? tooltipCustomerDemand : ''} units</span>
                  </Styled.TooltipCost>
                </Styled.Tooltip1>

                {factories.length > 0 && (
                  <Styled.MapIcon
                    x={495}
                    y={145}
                    onMouseEnter={this.showTooltip1}
                    onMouseLeave={this.hideTooltip1}
                    onClick={distributionCenter && canSelectDistributionCenters && activeDistributionCenter === 0 ? () => this.showSelectDistributionCenterFacilityPopup() : null}
                  >
                    <img src={MapIcon2} alt="map icon facilities" />
                  </Styled.MapIcon>
                )}

                {factories.length > 0 && tooltip1 && (() => {
                  const facility = (distributionCentersInfo || []).find(i => i.type === 'facility');
                  const totalAvailable = (products || []).reduce(
                    (s, p) => s + (Number(p.available_for_sale) || 0),
                    0
                  );
                  const totalAllocated = (inventory_allocations || []).reduce(
                    (s, a) => s + (Number(a.units) || 0),
                    0
                  );
                  const inventoryAtFacility = Math.max(0, Math.round(totalAvailable - totalAllocated));
                  return (
                    <Styled.Tooltip1
                      show={true}
                      top={100}
                      left={210}
                      onMouseEnter={this.showTooltip1}
                      onMouseLeave={this.hideTooltip1}
                    >
                      <Styled.TooltipTitle background="#e8eaf0">
                        <img src={MapIcon2} alt="facility icon" />
                        {facility ? facility.location : ''}
                      </Styled.TooltipTitle>
                      <Styled.TooltipCost>
                        Production Facility
                        <Styled.TooltipSpace />
                        Inventory Allocated: <span>{inventoryAtFacility.toLocaleString('en-US')}</span>
                      </Styled.TooltipCost>
                    </Styled.Tooltip1>
                  );
                })()}

                {factories.length > 0 && canSelectDistributionCenters && !ownedDcTypeToTeamCenterId[1] && !(leadTimesLoaded && activeDistributionCenter === 1) && (
                  <Styled.GlowingMapIcon
                    x={338} y={135}
                    onMouseEnter={selectDistributionCenterFacilityPopup ? null : this.hoverDistributionCenter(1)}
                    onMouseLeave={this.unhoverDistributionCenter}
                  >
                    <img src={MapIcon3} alt="map icon select-center-yellow" />
                  </Styled.GlowingMapIcon>
                )}

                {factories.length > 0 && canSelectDistributionCenters && !ownedDcTypeToTeamCenterId[1] && (
                  <Styled.Tooltip1
                    show={hoveredDistributionCenter === 1}
                    top={55}
                    left={80}
                    onMouseEnter={this.cancelDistributionCenterUnhover}
                    onMouseLeave={this.unhoverDistributionCenter}
                  >
                    <Styled.TooltipTitle background="#fbedd5">
                      <img src={MapHoverIcon2} alt="map icon" />
                      {hoveredDistribution ? hoveredDistribution.location : ''}
                    </Styled.TooltipTitle>
                    <Styled.TooltipCost>
                      <span>{DC_3PL_NAMES[hoveredDistributionCenter] || ''}</span>
                      <Styled.TooltipSpace />
                      Cost: <span>${hoveredDistribution ? (hoveredDistribution.cost / 1e6).toFixed(2) : ''}M</span>
                      <Styled.TooltipSpace />
                      Lease Payment Terms: Payment is spread over 5 years through equal annual installments, with a 1% interest charge applied.
                    </Styled.TooltipCost>
                    <Styled.TooltipButtonRow>
                      <Styled.TooltipButton onClick={this.calculateDistance}>View Details</Styled.TooltipButton>
                    </Styled.TooltipButtonRow>
                  </Styled.Tooltip1>
                )}

                {factories.length > 0 && ownedDcTypeToTeamCenterId[1] && (
                  <Styled.Tooltip1
                    show={hoveredDistributionCenter === 1}
                    top={55}
                    left={80}
                    onMouseEnter={this.cancelDistributionCenterUnhover}
                    onMouseLeave={this.unhoverDistributionCenter}
                  >
                    <Styled.TooltipTitle background="#fbedd5">
                      <img src={MapHoverIcon2} alt="map icon" />
                      {hoveredDistribution ? hoveredDistribution.location : ''}
                    </Styled.TooltipTitle>
                    <Styled.TooltipCost>
                      <span>{DC_3PL_NAMES[hoveredDistributionCenter] || ''}</span>
                      <Styled.TooltipSpace />
                      Inventory Allocated: <span>{dcOwnedStats(1).units.toLocaleString('en-US')}</span>
                      <Styled.TooltipSpace />
                      Transport Cost: <span>${Math.round(dcOwnedStats(1).shipping).toLocaleString('en-US')}</span>
                    </Styled.TooltipCost>
                    {showActionButtons === true && (
                      <Styled.TooltipButtonRow>
                        <Styled.TooltipButton onClick={this.editDistributionCenter(1)}>Edit</Styled.TooltipButton>
                      </Styled.TooltipButtonRow>
                    )}
                  </Styled.Tooltip1>
                )}

                {factories.length > 0 && canSelectDistributionCenters && !ownedDcTypeToTeamCenterId[2] && !(leadTimesLoaded && activeDistributionCenter === 2) && (
                  <Styled.GlowingMapIcon
                    x={275} y={208}
                    onMouseEnter={selectDistributionCenterFacilityPopup ? null : this.hoverDistributionCenter(2)}
                    onMouseLeave={this.unhoverDistributionCenter}
                  >
                    <img src={MapIcon4} alt="map icon select-center-purple" />
                  </Styled.GlowingMapIcon>
                )}

                {factories.length > 0 && canSelectDistributionCenters && !ownedDcTypeToTeamCenterId[2] && (
                  <Styled.Tooltip1
                    show={hoveredDistributionCenter === 2}
                    top={10}
                    left={175}
                    onMouseEnter={this.cancelDistributionCenterUnhover}
                    onMouseLeave={this.unhoverDistributionCenter}
                  >
                    <Styled.TooltipTitle background="#eae4f9">
                      <img src={MapHoverIcon3} alt="map icon" />
                      {hoveredDistribution ? hoveredDistribution.location : ''}
                    </Styled.TooltipTitle>
                    <Styled.TooltipCost>
                      <span>{DC_3PL_NAMES[hoveredDistributionCenter] || ''}</span>
                      <Styled.TooltipSpace />
                      Cost: <span>${hoveredDistribution ? (hoveredDistribution.cost / 1e6).toFixed(2) : ''}M</span>
                      <Styled.TooltipSpace />
                      Lease Payment Terms: Payment is spread over 5 years through equal annual installments, with a 1% interest charge applied.
                    </Styled.TooltipCost>
                    <Styled.TooltipButtonRow>
                      <Styled.TooltipButton onClick={this.calculateDistance}>View Details</Styled.TooltipButton>
                    </Styled.TooltipButtonRow>
                  </Styled.Tooltip1>
                )}

                {factories.length > 0 && ownedDcTypeToTeamCenterId[2] && (
                  <Styled.Tooltip1
                    show={hoveredDistributionCenter === 2}
                    top={10}
                    left={175}
                    onMouseEnter={this.cancelDistributionCenterUnhover}
                    onMouseLeave={this.unhoverDistributionCenter}
                  >
                    <Styled.TooltipTitle background="#eae4f9">
                      <img src={MapHoverIcon3} alt="map icon" />
                      {hoveredDistribution ? hoveredDistribution.location : ''}
                    </Styled.TooltipTitle>
                    <Styled.TooltipCost>
                      <span>{DC_3PL_NAMES[hoveredDistributionCenter] || ''}</span>
                      <Styled.TooltipSpace />
                      Inventory Allocated: <span>{dcOwnedStats(2).units.toLocaleString('en-US')}</span>
                      <Styled.TooltipSpace />
                      Transport Cost: <span>${Math.round(dcOwnedStats(2).shipping).toLocaleString('en-US')}</span>
                    </Styled.TooltipCost>
                    {showActionButtons === true && (
                      <Styled.TooltipButtonRow>
                        <Styled.TooltipButton onClick={this.editDistributionCenter(2)}>Edit</Styled.TooltipButton>
                      </Styled.TooltipButtonRow>
                    )}
                  </Styled.Tooltip1>
                )}

                {factories.length > 0 && canSelectDistributionCenters && !ownedDcTypeToTeamCenterId[3] && !(leadTimesLoaded && activeDistributionCenter === 3) && (
                  <Styled.GlowingMapIcon
                    x={111} y={189}
                    onMouseEnter={selectDistributionCenterFacilityPopup ? null : this.hoverDistributionCenter(3)}
                    onMouseLeave={this.unhoverDistributionCenter}
                  >
                    <img src={MapIcon5} alt="map icon select-center-green" />
                  </Styled.GlowingMapIcon>
                )}

                {factories.length > 0 && canSelectDistributionCenters && !ownedDcTypeToTeamCenterId[3] && (
                  <Styled.Tooltip1
                    show={hoveredDistributionCenter === 3}
                    top={105}
                    left={155}
                    onMouseEnter={this.cancelDistributionCenterUnhover}
                    onMouseLeave={this.unhoverDistributionCenter}
                  >
                    <Styled.TooltipTitle background="#d7f0f2">
                      <img src={MapHoverIcon4} alt="map icon" />
                      {hoveredDistribution ? hoveredDistribution.location : ''}
                    </Styled.TooltipTitle>
                    <Styled.TooltipCost>
                      <span>{DC_3PL_NAMES[hoveredDistributionCenter] || ''}</span>
                      <Styled.TooltipSpace />
                      Cost: <span>${hoveredDistribution ? (hoveredDistribution.cost / 1e6).toFixed(2) : ''}M</span>
                      <Styled.TooltipSpace />
                      Lease Payment Terms: Payment is spread over 5 years through equal annual installments, with a 1% interest charge applied.
                    </Styled.TooltipCost>
                    <Styled.TooltipButtonRow>
                      <Styled.TooltipButton onClick={this.calculateDistance}>View Details</Styled.TooltipButton>
                    </Styled.TooltipButtonRow>
                  </Styled.Tooltip1>
                )}

                {factories.length > 0 && ownedDcTypeToTeamCenterId[3] && (
                  <Styled.Tooltip1
                    show={hoveredDistributionCenter === 3}
                    top={105}
                    left={155}
                    onMouseEnter={this.cancelDistributionCenterUnhover}
                    onMouseLeave={this.unhoverDistributionCenter}
                  >
                    <Styled.TooltipTitle background="#d7f0f2">
                      <img src={MapHoverIcon4} alt="map icon" />
                      {hoveredDistribution ? hoveredDistribution.location : ''}
                    </Styled.TooltipTitle>
                    <Styled.TooltipCost>
                      <span>{DC_3PL_NAMES[hoveredDistributionCenter] || ''}</span>
                      <Styled.TooltipSpace />
                      Inventory Allocated: <span>{dcOwnedStats(3).units.toLocaleString('en-US')}</span>
                      <Styled.TooltipSpace />
                      Transport Cost: <span>${Math.round(dcOwnedStats(3).shipping).toLocaleString('en-US')}</span>
                    </Styled.TooltipCost>
                    {showActionButtons === true && (
                      <Styled.TooltipButtonRow>
                        <Styled.TooltipButton onClick={this.editDistributionCenter(3)}>Edit</Styled.TooltipButton>
                      </Styled.TooltipButtonRow>
                    )}
                  </Styled.Tooltip1>
                )}

                {canSelectDistributionCenters && distributionCenter && (
                  <Styled.Tooltip1 show={selectDistributionCenterFacilityPopup} top={105} left={155}>
                    <Styled.TooltipTitle background="#FBD8D8">
                      <img src={MapHoverIcon1} alt="map icon" />
                      Newark, NJ
                    </Styled.TooltipTitle>
                    <Styled.TooltipButtonRow>
                      <Styled.TooltipButton onClick={this.showDeselectLocationAlert}>Select</Styled.TooltipButton>
                    </Styled.TooltipButtonRow>
                  </Styled.Tooltip1>
                )}

                {leadTimesLoaded && activeDistributionCenter > 0 && DC_CENTER_POSITIONS[activeDistributionCenter] && (
                  <svg
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      pointerEvents: 'none',
                      overflow: 'visible',
                    }}
                  >
                    {CUSTOMER_DOT_POSITIONS.map(c => (
                      <line
                        key={`leadline-${c.id}`}
                        x1={DC_CENTER_POSITIONS[activeDistributionCenter].x}
                        y1={DC_CENTER_POSITIONS[activeDistributionCenter].y}
                        x2={c.x}
                        y2={c.y}
                        stroke="rgba(135, 99, 255, 0.5)"
                        strokeWidth="1.5"
                      />
                    ))}
                  </svg>
                )}
                {((leadTimesLoaded && activeDistributionCenter === 1) || (!leadTimesLoaded && ownedDcTypeToTeamCenterId[1])) && (
                  <Styled.MapIcon
                    x={338} y={135}
                    onMouseEnter={this.hoverDistributionCenter(1)}
                    onMouseLeave={this.unhoverDistributionCenter}
                  >
                    <img src={MapIcon6} alt="map icon selected-center-yellow" />
                  </Styled.MapIcon>
                )}

                {((leadTimesLoaded && activeDistributionCenter === 2) || (!leadTimesLoaded && ownedDcTypeToTeamCenterId[2])) && (
                  <Styled.MapIcon
                    x={275} y={208}
                    onMouseEnter={this.hoverDistributionCenter(2)}
                    onMouseLeave={this.unhoverDistributionCenter}
                  >
                    <img src={MapIcon7} alt="map icon selected-center-purple" />
                  </Styled.MapIcon>
                )}

                {((leadTimesLoaded && activeDistributionCenter === 3) || (!leadTimesLoaded && ownedDcTypeToTeamCenterId[3])) && (
                  <Styled.MapIcon
                    x={111} y={189}
                    onMouseEnter={this.hoverDistributionCenter(3)}
                    onMouseLeave={this.unhoverDistributionCenter}
                  >
                    <img src={MapIcon8} alt="map icon selected-center-green" />
                  </Styled.MapIcon>
                )}
                {this.state.devMapMode && (
                  <Styled.DevMapOverlay onClick={this.handleDevMapClick}>
                    <Styled.DevMapBanner>
                      DEV MAP MODE — click anywhere to log coords (also printed to console)
                    </Styled.DevMapBanner>
                    {this.state.devMapLastClick && (
                      <Styled.DevMapCoord
                        top={this.state.devMapLastClick.rawY}
                        left={this.state.devMapLastClick.rawX}
                      >
                        x={this.state.devMapLastClick.x} y={this.state.devMapLastClick.y}
                      </Styled.DevMapCoord>
                    )}
                  </Styled.DevMapOverlay>
                )}
              </Styled.GoogleMap>
                </FinanceStyled.SectionCard>
              </Styled.OpsLeadGridMarket>
              <Styled.OpsLeadGridRight
                fillHeight={showDistributionCenters && !leadTimesLoaded}
                style={showDistributionCenters
                  ? { position: 'relative', zIndex: 900 }
                  : undefined}
              >
                {showDistributionCenters && !leadTimesLoaded && (
                  <FinanceStyled.SectionCard style={{ position: 'relative', height: '100%' }}>
                    <Styled.ManageDistributionClose onClick={this.hideDistributionCenters} aria-label="Close">
                      ×
                    </Styled.ManageDistributionClose>
                    <FinanceStyled.SectionTitle>Manage Distribution</FinanceStyled.SectionTitle>
                    <Styled.ManageDistributionBody>
                      <p>
                        You can now partner with distribution centers to position inventory closer to your customers.
                        Right now, every order ships from your production facility, which means customers far from your
                        plant wait longer, and long lead times can cost you sales.
                      </p>
                      <p>
                        A well-placed distribution center shortens lead times, improves customer satisfaction, and helps
                        you capture revenue that would otherwise go to faster competitors.
                      </p>
                      <p>
                        Three locations are available, and you can choose any one, two, or all three. Each distribution center comes with a cost, structured as a 5-year lease. You will make one payment at the start of each year for five years, and those annual payments together make up the total lease cost.
                      </p>
                    </Styled.ManageDistributionBody>
                  </FinanceStyled.SectionCard>
                )}
                {leadTimesLoaded && (
                  <FinanceStyled.SectionCard>
                    <Styled.DistributionTitle>
                      {activeDistributionCenter === 1 && (
                        <img src={MapIcon6} alt="icon" />
                      )}
                      {activeDistributionCenter === 2 && (
                        <img src={MapIcon7} alt="icon" />
                      )}
                      {activeDistributionCenter === 3 && (
                        <img src={MapIcon8} alt="icon" />
                      )}
                      <div>{distribution ? distribution.name : ''}</div>
                    </Styled.DistributionTitle>
                    {/* 2-column layout: narrow lead-time table on the left,
                        per-product allocations + action buttons on the right
                        so all three are visible without scrolling. */}
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: '0.85fr 1.15fr',
                      gap: 24,
                      alignItems: 'stretch',
                      marginTop: 12,
                    }}>
                      <div>
                        <Styled.DistributionTableRow>
                          <Styled.DistributionTableCell isHeader={true}>Customer</Styled.DistributionTableCell>
                          <Styled.DistributionTableCell isHeader={true}>Lead Time <span>(h)</span></Styled.DistributionTableCell>
                        </Styled.DistributionTableRow>
                        {leadTimes.map(leadTime => (
                          <Styled.DistributionTableRow key={`distribution-table-row-${leadTime.id}`}>
                            <Styled.DistributionTableCell>{leadTime.customer}</Styled.DistributionTableCell>
                            <Styled.DistributionTableCell>{Number(leadTime.avg_time.toFixed(2))}</Styled.DistributionTableCell>
                          </Styled.DistributionTableRow>
                        ))}
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div style={{
                          fontFamily: "'Mukta Vaani', Lato, sans-serif",
                          fontWeight: 600, fontSize: 11, letterSpacing: '0.5px',
                          textTransform: 'uppercase', color: 'rgba(0, 27, 59, 0.6)',
                          marginBottom: 8
                        }}>
                          Allocate Inventory
                        </div>
                        {(products || []).map(product => {
                          const productId = product.product_id;
                          // Max Allocation = ceiling for what the user can
                          // assign to THIS DC right now: everything still at
                          // the facility, PLUS whatever this DC has already
                          // committed (so editing doesn't shrink the ceiling
                          // by the pre-filled value). available_for_sale from
                          // the backend doesn't subtract committed
                          // allocations, so we subtract sums from
                          // inventory_allocations and exclude this DC when
                          // editing.
                          const currentTcId = editingExistingDc
                            ? ownedDcTypeToTeamCenterId[activeDistributionCenter]
                            : null;
                          const allocatedElsewhere = (inventory_allocations || [])
                            .filter(a => Number(a.product) === Number(productId))
                            .filter(a => !currentTcId || Number(a.team_distribution_center) !== Number(currentTcId))
                            .reduce((sum, a) => sum + (Number(a.units) || 0), 0);
                          const available = Math.max(
                            0,
                            Math.round((Number(product.available_for_sale) || 0) - allocatedElsewhere)
                          );
                          const rawValue = allocations && allocations[productId];
                          const displayValue = rawValue ? Number(rawValue).toLocaleString('en-US') : '';
                          return (
                            <div key={`alloc-${productId}`} style={{
                              display: 'flex',
                              alignItems: 'flex-end',
                              gap: 8,
                              marginBottom: 10,
                            }}>
                              {/* Inner column: header row + input share the
                                  same width so the right edge of "Available"
                                  lines up with the right edge of the input. */}
                              <div style={{ flex: 1 }}>
                                <div style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'baseline',
                                  marginBottom: 4
                                }}>
                                  <span style={{
                                    fontFamily: "'Mukta Vaani', Lato, sans-serif",
                                    fontWeight: 600,
                                    fontSize: 14,
                                    color: 'rgba(0, 27, 59, 0.94)'
                                  }}>
                                    Product: {product.product_name}
                                  </span>
                                  <span style={{
                                    fontFamily: "'Mukta Vaani', Lato, sans-serif",
                                    fontSize: 12,
                                    color: 'rgba(0, 27, 59, 0.55)'
                                  }}>
                                    Max Allocation: {available.toLocaleString('en-US')} units
                                  </span>
                                </div>
                                <input
                                  type="text"
                                  value={displayValue}
                                  onChange={this.setAllocation(productId)}
                                  placeholder="0"
                                  disabled={available === 0}
                                  style={{
                                    width: '100%',
                                    boxSizing: 'border-box',
                                    padding: '8px 12px',
                                    borderRadius: 6,
                                    border: '1px solid #D5D9DD',
                                    fontFamily: "'Mukta Vaani', Lato, sans-serif",
                                    fontSize: 14,
                                    fontWeight: 600,
                                    color: 'rgba(0, 27, 59, 0.94)',
                                    background: available === 0 ? '#F5F6F7' : '#fff',
                                  }}
                                />
                              </div>
                              <span style={{
                                fontFamily: "'Mukta Vaani', Lato, sans-serif",
                                fontSize: 13,
                                color: 'rgba(0, 27, 59, 0.6)',
                                paddingBottom: 10,
                              }}>
                                units
                              </span>
                            </div>
                          );
                        })}
                        {/* Pushes Cancel + Partner buttons to the bottom of
                            the right column so they sit flush with the
                            bottom of the lead-time table on the left. */}
                        <div style={{ marginTop: 'auto', paddingTop: 12 }}>
                          <Styled.DistributionButtons>
                            {editingExistingDc ? (
                              <Fragment>
                                <Styled.DistributionSubmitButton onClick={openingDistributionCenter ? null : this.updateAllocation} disabled={openingDistributionCenter}>
                                  {openingDistributionCenter ? 'Loading...' : 'Update Allocation'}
                                </Styled.DistributionSubmitButton>
                                <Styled.DistributionCancelButton onClick={this.cancelAgreement}>Cancel Agreement</Styled.DistributionCancelButton>
                                <Styled.DistributionCancelButton onClick={this.cancelDistributionCenter}>Cancel</Styled.DistributionCancelButton>
                              </Fragment>
                            ) : (
                              <Fragment>
                                <Styled.DistributionSubmitButton onClick={openingDistributionCenter ? null : this.showPartnerConfirmation} disabled={openingDistributionCenter}>
                                  {openingDistributionCenter ? 'Loading...' : 'Allocate to Distribution Center'}
                                </Styled.DistributionSubmitButton>
                                <Styled.DistributionCancelButton onClick={this.cancelDistributionCenter}>Cancel</Styled.DistributionCancelButton>
                              </Fragment>
                            )}
                          </Styled.DistributionButtons>
                        </div>
                      </div>
                    </div>
                  </FinanceStyled.SectionCard>
                )}
                {!leadTimesLoaded && !showDistributionCenters && this.totalAvailableForSale > 0 && (
                  <FinanceStyled.SectionCard>
                    <FinanceStyled.SectionHeader>
                      <FinanceStyled.SectionTitle>Inventory Management</FinanceStyled.SectionTitle>
                    </FinanceStyled.SectionHeader>
                    <FinanceStyled.SummaryTable>
                      <thead>
                        <FinanceStyled.SummaryHeadRow>
                          <FinanceStyled.SummaryHeadCell>Product</FinanceStyled.SummaryHeadCell>
                          <FinanceStyled.SummaryHeadCell align="right">Beg. Inventory</FinanceStyled.SummaryHeadCell>
                          <FinanceStyled.SummaryHeadCell align="right">Units Produced</FinanceStyled.SummaryHeadCell>
                          <FinanceStyled.SummaryHeadCell align="right">Available Units for Sale</FinanceStyled.SummaryHeadCell>
                          <FinanceStyled.SummaryHeadCell align="right">Cost Per Unit</FinanceStyled.SummaryHeadCell>
                        </FinanceStyled.SummaryHeadRow>
                      </thead>
                      <tbody>
                        {(products || []).map((p, i) => {
                          const tp = (team_products || []).find(t => Number(t.id) === Number(p.product_id));
                          const monthsAvailable = tp ? Number(tp.months_available_to_produce) || 0 : 0;
                          const notReleased = monthsAvailable === 0;
                          return (
                          <FinanceStyled.SummaryRow key={`inv-row-${i}`}>
                            <FinanceStyled.SummaryCell>
                              <span style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 8,
                              }}>
                                {p.product_name}
                                {showActionButtons === true && Number(p.available_for_sale || 0) > 0 && (
                                <button
                                  type="button"
                                  onClick={this.requestDeleteProduction(p.product_id)}
                                  aria-label={`Delete production for ${p.product_name}`}
                                  title={`Delete production for ${p.product_name}`}
                                  style={{
                                    background: 'transparent',
                                    border: '1.5px solid #E5E9F0',
                                    borderRadius: 8,
                                    width: 28,
                                    height: 28,
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'rgba(0, 27, 59, 0.6)',
                                    cursor: 'pointer',
                                    padding: 0,
                                  }}
                                  onMouseEnter={(ev) => {
                                    ev.currentTarget.style.borderColor = '#DC2626';
                                    ev.currentTarget.style.color = '#DC2626';
                                  }}
                                  onMouseLeave={(ev) => {
                                    ev.currentTarget.style.borderColor = '#E5E9F0';
                                    ev.currentTarget.style.color = 'rgba(0, 27, 59, 0.6)';
                                  }}
                                >
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="3 6 5 6 21 6" />
                                    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                                    <path d="M10 11v6" />
                                    <path d="M14 11v6" />
                                    <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
                                  </svg>
                                </button>
                                )}
                                {notReleased && (
                                  <span
                                    style={{ position: 'relative', display: 'inline-flex' }}
                                    onMouseEnter={() => this.setState({ hoveredNotReleasedProductId: p.product_id })}
                                    onMouseLeave={() => this.setState({ hoveredNotReleasedProductId: 0 })}
                                  >
                                    <span style={{
                                      display: 'inline-block',
                                      padding: '2px 10px',
                                      borderRadius: 20,
                                      background: '#FFF1DD',
                                      color: '#C77700',
                                      border: '1px solid #F0CB91',
                                      fontFamily: "'Mukta Vaani', Lato, sans-serif",
                                      fontWeight: 700,
                                      fontSize: 11,
                                      lineHeight: '14px',
                                      letterSpacing: '0.3px',
                                      whiteSpace: 'nowrap',
                                      cursor: 'help',
                                    }}>
                                      Not Yet Released
                                    </span>
                                    {Number(hoveredNotReleasedProductId) === Number(p.product_id) && (
                                      <span style={{
                                        position: 'absolute',
                                        bottom: '100%',
                                        left: '50%',
                                        transform: 'translateX(-50%) translateY(-8px)',
                                        background: 'rgba(0, 27, 59, 0.94)',
                                        color: '#fff',
                                        fontFamily: "'Mukta Vaani', Lato, sans-serif",
                                        fontWeight: 500,
                                        fontSize: 13,
                                        lineHeight: '18px',
                                        padding: '8px 12px',
                                        borderRadius: 6,
                                        width: 240,
                                        textAlign: 'center',
                                        pointerEvents: 'none',
                                        zIndex: 10,
                                      }}>
                                        Check with your Head of Product or CEO about the release date with this product.
                                      </span>
                                    )}
                                  </span>
                                )}
                              </span>
                            </FinanceStyled.SummaryCell>
                            <FinanceStyled.SummaryCell align="right">
                              {Number(p.beginning_inventory || 0).toLocaleString('en-US')}
                            </FinanceStyled.SummaryCell>
                            <FinanceStyled.SummaryCell align="right">
                              {Number(p.units_produced || 0).toLocaleString('en-US')}
                            </FinanceStyled.SummaryCell>
                            <FinanceStyled.SummaryCell align="right">
                              {Number(p.available_for_sale || 0).toLocaleString('en-US')}
                            </FinanceStyled.SummaryCell>
                            <FinanceStyled.SummaryCell align="right">
                              ${Number(p.cost_per_unit || 0).toFixed(2)}
                            </FinanceStyled.SummaryCell>
                          </FinanceStyled.SummaryRow>
                          );
                        })}
                        {(!products || products.length === 0) && (
                          <FinanceStyled.SummaryRow>
                            <FinanceStyled.SummaryCell colSpan={5}>&mdash;</FinanceStyled.SummaryCell>
                          </FinanceStyled.SummaryRow>
                        )}
                      </tbody>
                    </FinanceStyled.SummaryTable>
                  </FinanceStyled.SectionCard>
                )}
                {!leadTimesLoaded && !showDistributionCenters && (supply_chain_assets || []).length > 0 && (
                  <FinanceStyled.SectionCard>
                    <FinanceStyled.SectionHeader>
                      <FinanceStyled.SectionTitle>Supply Chain Assets</FinanceStyled.SectionTitle>
                    </FinanceStyled.SectionHeader>
                    <FinanceStyled.SummaryTable>
                      <thead>
                        <FinanceStyled.SummaryHeadRow>
                          <FinanceStyled.SummaryHeadCell>Asset</FinanceStyled.SummaryHeadCell>
                          <FinanceStyled.SummaryHeadCell align="right">Cost</FinanceStyled.SummaryHeadCell>
                        </FinanceStyled.SummaryHeadRow>
                      </thead>
                      <tbody>
                        {(supply_chain_assets || []).map((asset, i) => (
                          <FinanceStyled.SummaryRow key={`asset-${asset.type || ''}-${asset.id || i}`}>
                            <FinanceStyled.SummaryCell>{asset.name}</FinanceStyled.SummaryCell>
                            <FinanceStyled.SummaryCell align="right">
                              ${Math.round(Number(asset.costs) || 0).toLocaleString('en-US')}
                            </FinanceStyled.SummaryCell>
                          </FinanceStyled.SummaryRow>
                        ))}
                      </tbody>
                    </FinanceStyled.SummaryTable>
                  </FinanceStyled.SectionCard>
                )}
              </Styled.OpsLeadGridRight>
            </Styled.OpsLeadGrid>
          </div>
        )}
        {loaded === false && <Loader type="ball-scale-ripple" active />}
        <SelectFacilityPopup
          show={selectFacilityPopupShown}
          facilityPopup={facilityPopup}
          action={this.onCreateFactory}
          close={this.hideFacilityPopupShown}
        />
        {/* DistributionCentersPopup retired: the Manage Distribution
            panel now renders inline inside OpsLeadGridRight when
            showDistributionCenters is true. */}
        {showPartnerConfirmation && (() => {
          // Fall back to looking up the distribution from
          // distributionCentersInfo if state.distribution somehow was
          // cleared between selecting a DC and clicking Allocate. Without
          // this fallback the confirmation modal silently didn't render.
          const dist = distribution
            || (distributionCentersInfo || []).find(i => Number(i.type) === Number(activeDistributionCenter))
            || null;
          if (!dist) return null;
          return (
            <WarningAlert
              title="Confirm Distribution Agreement"
              successButtonText="Confirm"
              maxWidth={500}
              onSuccess={this.confirmPartnerConfirmation}
              onCancel={this.cancelPartnerConfirmation}
              message={(
                <span>
                  You're about to enter into a distribution agreement with <strong>{DC_3PL_NAMES[activeDistributionCenter] || 'this distributor'}</strong>
                  {' '}for the <strong>{dist.location || dist.name}</strong> distribution center. This will allow your team to transport inventory to this location.
                  <br /><br />
                  <strong>Cost:</strong> ${(Number(dist.cost || 0) / 1e6).toFixed(2)}M<br />
                  <strong>Lease Payment Terms:</strong> Payment is spread over 5 years through equal annual installments, with a 1% interest charge applied.<br />
                  <strong>Annual Payments:</strong> ${Math.round(Number(dist.lease_cash_payment_per_period) || 0).toLocaleString('en-US')}<br />
                  <strong>Shipping Costs:</strong> {(() => {
                    const totalAlloc = Object.values(allocations || {})
                      .reduce((sum, v) => sum + (Number(v) || 0), 0);
                    const batchSize = Number(shipping_batch_size) || 0;
                    const perBatch = Number(dist.shipping_cost_per_batch) || 0;
                    const cost = batchSize > 0 ? (totalAlloc / batchSize) * perBatch : 0;
                    return `$${Math.round(cost).toLocaleString('en-US')}`;
                  })()}
                  <br /><br />
                  Are you sure?
                </span>
              )}
            />
          );
        })()}
        {allocationValidationError && allocationValidationError.kind === 'overage' && (
          <WarningAlert
            title="Allocation Exceeds Max Allocation"
            successButtonText="OK"
            showCancel={false}
            onSuccess={this.dismissAllocationValidationError}
            onCancel={this.dismissAllocationValidationError}
            message={(
              <span>
                {allocationValidationError.rows.length === 1 ? (
                  <span>
                    You've allocated more units than are available for <strong>{allocationValidationError.rows[0].name}</strong>.
                  </span>
                ) : (
                  <span>
                    You've allocated more units than are available for the following products:
                  </span>
                )}
                <br /><br />
                {allocationValidationError.rows.map((row, idx) => (
                  <span key={idx}>
                    <strong>{row.name}:</strong> allocated {row.requested.toLocaleString('en-US')} units, max {row.available.toLocaleString('en-US')} units
                    <br />
                  </span>
                ))}
                <br />
                Reduce each allocation to at most the Max Allocation and try again.
              </span>
            )}
          />
        )}
        {allocationValidationError && allocationValidationError.kind === 'zero' && (
          <WarningAlert
            title="No Units Allocated"
            successButtonText="OK"
            showCancel={false}
            onSuccess={this.dismissAllocationValidationError}
            onCancel={this.dismissAllocationValidationError}
            message={(
              <span>
                Allocate at least one unit to this distribution center before partnering. Enter a value greater than 0 for at least one product.
              </span>
            )}
          />
        )}
        {showCancelAgreementConfirmation && (
          <WarningAlert
            title="Cancel Agreement"
            successButtonText="Yes, Cancel Agreement"
            onSuccess={this.confirmCancelAgreement}
            onCancel={this.hideCancelAgreementConfirmation}
            message={(
              <span>
                Canceling will end your partnership with this distribution center (i.e. you won't be able to allocate inventory to this location).
                <br /><br />
                If you cancel in the same round you signed the agreement: no breakage fee.
                <br /><br />
                If the agreement was made in a prior round, canceling will result in a 10% breakage fee based off the remaining of what you owe.
                <br /><br />
                You can always create a new agreement with this distribution center.
              </span>
            )}
          />
        )}
        {this.state.deleteProductionProductId != null && (() => {
          const target = (products || []).find(
            p => Number(p.product_id) === Number(this.state.deleteProductionProductId)
          );
          const productName = target ? target.product_name : 'this product';
          return (
            <WarningAlert
              title="Delete Production"
              successButtonText="Yes, Delete"
              onSuccess={this.confirmDeleteProduction}
              onCancel={this.cancelDeleteProduction}
              message={(
                <span>
                  Are you sure you want to delete production for <strong>{productName}</strong>? This will remove your production decision for this product this round.
                </span>
              )}
            />
          );
        })()}
        {this.state.showManageProductionPage && (
          <ManageProductionPage
            products={products}
            teamProducts={team_products}
            priceForecasts={price_forecasts}
            maxAllowedMatrix={max_allowed_matrix}
            inventoryBalances={this.state.inventory_balances}
            inventoryAllocations={this.state.inventory_allocations}
            currentRound={currentRound}
            reloadData={this.fetchData}
            onClose={this.closeManageProductionPage}
            onFirstProductionInRound2={this.handleFirstProductionInRound2}
          />
        )}
        <FirstDecisionModal
          open={this.state.firstDistributionModalOpen}
          title="Nice work!"
          body="Starting this round, you can make distribution center decisions to move your inventory closer to where your target customers are."
          ctaLabel="View Distribution Center Decisions"
          onCta={this.handleFirstDistributionCta}
          onClose={this.handleFirstDistributionClose}
        />

        {this.state.showMakeDecisionsModal && (() => {
          const hasProducts = (products || []).length > 0;
          const hasMachines = (team_machines || []).length > 0;
          const hasAvailableUnits = this.totalAvailableForSale > 0;
          const produceEnabled = hasProducts && hasMachines;
          const distributionEnabled = currentRound !== 1 && hasAvailableUnits;
          return (
            <FinanceStyled.ManageOverlay onClick={this.closeMakeDecisionsModal}>
              <FinanceStyled.ManageModal onClick={e => e.stopPropagation()} style={{ maxWidth: 760 }}>
                <FinanceStyled.ManageModalTitle>Make Decisions</FinanceStyled.ManageModalTitle>
                <FinanceStyled.ManageModalSubtitle>Select a decision to explore</FinanceStyled.ManageModalSubtitle>
                <Styled.DecisionFlowRow>
                  <Styled.DecisionOptionWrapper>
                    <FinanceStyled.ManageOption
                      onClick={this.pickMakeDecisionsOption('buy-sell-machines')}
                    >
                      Acquire/Sell Machines
                    </FinanceStyled.ManageOption>
                    <Styled.DecisionOptionTooltip>
                      Add or remove production machines from your facility.
                    </Styled.DecisionOptionTooltip>
                  </Styled.DecisionOptionWrapper>
                  <Styled.DecisionFlowArrow>→</Styled.DecisionFlowArrow>
                  <Styled.DecisionOptionWrapper>
                    <FinanceStyled.ManageOption
                      onClick={produceEnabled ? this.pickMakeDecisionsOption('produce-units') : undefined}
                      disabled={!produceEnabled}
                    >
                      Manage Production
                    </FinanceStyled.ManageOption>
                    <Styled.DecisionOptionTooltip>
                      {produceEnabled
                        ? 'Schedule production runs for this round.'
                        : !hasProducts
                          ? 'No products exist yet. Coordinate with Product Development to create a product first.'
                          : "You don't have any production machines yet. Acquire one before managing production."}
                    </Styled.DecisionOptionTooltip>
                  </Styled.DecisionOptionWrapper>
                  <Styled.DecisionFlowArrow>→</Styled.DecisionFlowArrow>
                  <Styled.DecisionOptionWrapper>
                    <FinanceStyled.ManageOption
                      onClick={distributionEnabled ? this.pickMakeDecisionsOption('distribution-center') : undefined}
                      disabled={!distributionEnabled}
                    >
                      Manage Distribution
                    </FinanceStyled.ManageOption>
                    <Styled.DecisionOptionTooltip>
                      {currentRound === 1
                        ? 'Decision unavailable for Round 1'
                        : !hasAvailableUnits
                          ? "You don't have any units available for sale yet. Manufacture units before opening a distribution center."
                          : 'Open or move your distribution center.'}
                    </Styled.DecisionOptionTooltip>
                  </Styled.DecisionOptionWrapper>
                </Styled.DecisionFlowRow>
                <FinanceStyled.ManageCloseRow>
                  <FinanceStyled.ManageCloseButton onClick={this.closeMakeDecisionsModal}>
                    Cancel
                  </FinanceStyled.ManageCloseButton>
                </FinanceStyled.ManageCloseRow>
              </FinanceStyled.ManageModal>
            </FinanceStyled.ManageOverlay>
          );
        })()}
      </Styled.BodyWrapper>
    );
  }
}

export default view(OperationsDecisions);



// WEBPACK FOOTER //
// ./src/containers/operations-decisions.js